// extracted by mini-css-extract-plugin
export default {"sectionHeaderBlock":"SectionHeader_sectionHeaderBlock__OpsGX","sectionHeader":"SectionHeader_sectionHeader__kSkqe"};